import { usePage } from '@inertiajs/react'
import { DashboardPageProps } from '@/types'

export function useBasePath() {
  const { auth } = usePage<DashboardPageProps>().props
  return `/${auth.account?.slug}`
}
